import { Response } from '@types';
import { call, put, retry, takeLatest } from 'redux-saga/effects';

import { captureException } from 'shared/utils/handlerErrors';
import { actions } from '.';
import { RETRY_DELAY_MS, RETRY_TIMES } from '../constants';
import {
  fetchPatientData,
  saveGuideData,
} from 'features/tissInvoicing/services/appointmentGuide';
import {
  AppointmentGuideFormValues,
  PatientData,
} from 'features/tissInvoicing/types/appointmentGuide';
import getSnackbarPayload from 'features/tissInvoicing/utils/getSnackbarPayload';

type FetchPatientOptions = ReturnType<typeof actions.fetchPatientData>;
type SaveGuideData = ReturnType<typeof actions.saveGuideData>;

export function* fetchPatientDataWorker({
  payload: { patientId },
}: FetchPatientOptions) {
  try {
    const { data }: Response<PatientData> = yield retry(
      RETRY_TIMES,
      RETRY_DELAY_MS,
      fetchPatientData,
      patientId,
    );

    yield put(actions.setPatientData(data));
  } catch (error) {
    captureException(error);
  }
}

export function* saveGuideDataWorker({ payload: { data } }: SaveGuideData) {
  try {
    yield put(actions.setLoading(true));

    const result: Response<AppointmentGuideFormValues> = yield call(
      saveGuideData,
      data,
    );

    yield put(
      actions.setSnackbarContent(
        getSnackbarPayload('Guia salva com sucesso', 'success'),
      ),
    );

    yield put(actions.setAppointmentGuide(result.data));
  } catch (error) {
    yield put(
      actions.setSnackbarContent(
        getSnackbarPayload('Houve um problema ao salvar a guia', 'error'),
      ),
    );
    captureException(error);
  } finally {
    yield put(actions.setLoading(false));
  }
}

export default function* watchSadtWorker() {
  yield takeLatest(actions.fetchPatientData, fetchPatientDataWorker);
  yield takeLatest(actions.saveGuideData, saveGuideDataWorker);
}
